import React, { useState, useEffect } from "react";
import Select from "react-dropdown";
import { useAddFaqCategory, useUpdateFaqCategory } from "../../../queryHooks";
import { addFAQCategorySchema } from "../../../validations";
import CS from "../../../services/commonService";
import { useFormik } from "formik";
import { useStore } from "../../../zustand/store";
//  Component starts
const AddUpdate = ({ category, onCloseModal, role_id }) => {
	//	Pre-defined values
	const statusOptions = [
		{ value: 1, label: "Active" },
		{ value: 0, label: "Inactive" },
	];
	//	State values
	const setLoading = useStore((state) => state.setLoading);
	const [status, setStatus] = useState(
		statusOptions.find((option) => option.value === category.is_active) || {
			value: 1,
			label: "Active",
		}
	);
	const [formData] = useState({
		name: category?.name,
		role_id,
	});

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: addFAQCategorySchema,
		onSubmit: (value) => {
			if (category.id) {
				updateFaqCategory({
					name: value.name?.trim(),
					is_active: status.value,
					id: category.id,
				});
				setLoading(true);
			} else {
				addFaqCategory({
					name: value.name?.trim(),
					role_id,
				});
				setLoading(true);
			}
		},
	});

	const {
		mutateAsync: addFaqCategory,
		error: errorAddFaqCategory,
		data: dataAddFaqCategory,
	} = useAddFaqCategory();

	useEffect(() => {
		if (dataAddFaqCategory) {
			setLoading(false);
			if (dataAddFaqCategory.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataAddFaqCategory.message);
			} else if (dataAddFaqCategory.status === "fail") {
				CS.showErrorMessage(dataAddFaqCategory.message);
			}
		}
	}, [dataAddFaqCategory]);

	useEffect(() => {
		if (errorAddFaqCategory) {
			setLoading(false);
			CS.showErrorMessage(errorAddFaqCategory.response?.data?.message);
		}
	}, [errorAddFaqCategory]);

	const {
		mutateAsync: updateFaqCategory,
		error: errorUpdateFaqCategory,
		data: dataUpdateFaqCategory,
	} = useUpdateFaqCategory();

	useEffect(() => {
		if (dataUpdateFaqCategory) {
			setLoading(false);
			if (dataUpdateFaqCategory.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataUpdateFaqCategory.message);
			} else if (dataUpdateFaqCategory.status === "fail") {
				CS.showErrorMessage(dataUpdateFaqCategory.message);
			}
		}
	}, [dataUpdateFaqCategory]);

	useEffect(() => {
		if (errorUpdateFaqCategory) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateFaqCategory.response?.data?.message);
		}
	}, [errorUpdateFaqCategory]);

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title">
					{" "}
					{category.id ? "Update Category" : "Add Category"}
				</h5>
			</div>
			<div className="notification-form modal-body card profile-card password-modal">
				<div className="row">
					<div className="col-md-12">
						<form onSubmit={handleSubmit}>
							<div className="mb-md-4 mb-3">
								<div className="form-group mb-0">
									<label className="label xl-label" htmlFor="faqCategoryName">
										Category Name<sup className="text-danger">*</sup>
									</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type="text"
											id="name"
											name="name"
											placeholder="Category Name"
											value={values.name}
											onChange={handleChange}
										/>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.name && touched.name ? errors.name : null}
											</span>
										</div>
									</div>
								</div>
							</div>
							{category.id && (
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Status<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<Select
												value={status}
												onChange={(option) => setStatus(option)}
												options={statusOptions}
											/>
										</div>
									</div>
								</div>
							)}
							<div className="mt-5 text-right">
								<button className="btn btn-primary" type="submit">
									{category.id ? "Update" : "Add"}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddUpdate;
